export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["उपयोगकर्ता नहीं मिला"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["चयन करें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["बंद करें"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खोज"])}
}